var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 7.33398V4.00065C3.33331 3.29341 3.61426 2.61513 4.11436 2.11503C4.61446 1.61494 5.29274 1.33398 5.99998 1.33398C6.70722 1.33398 7.3855 1.61494 7.8856 2.11503C8.38569 2.61513 8.66665 3.29341 8.66665 4.00065M2.66665 7.33398H9.33331C10.0697 7.33398 10.6666 7.93094 10.6666 8.66732V12.6673C10.6666 13.4037 10.0697 14.0007 9.33331 14.0007H2.66665C1.93027 14.0007 1.33331 13.4037 1.33331 12.6673V8.66732C1.33331 7.93094 1.93027 7.33398 2.66665 7.33398ZM6.66665 10.6673C6.66665 11.0355 6.36817 11.334 5.99998 11.334C5.63179 11.334 5.33331 11.0355 5.33331 10.6673C5.33331 10.2991 5.63179 10.0007 5.99998 10.0007C6.36817 10.0007 6.66665 10.2991 6.66665 10.6673Z",
    stroke: "#2EAB58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.bc517cdd150ed62c2a4bba56ef286767.svg";
export { ForwardRef as ReactComponent };